import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"
import { mergeClasses } from "../../helpers/styling"

type ProgressProps = React.ComponentProps<typeof ProgressPrimitive.Root> & {
  indeterminate?: boolean
  indicatorClassName?: string
}

export function ProgressBar(props: ProgressProps) {
  const { className, indicatorClassName, value, indeterminate, ...otherProps } = props
  const appliedValue = indeterminate ? 100 : value

  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={mergeClasses(
        "bg-muted h-1 rounded-full relative flex w-full items-center overflow-x-hidden", {
          "animate-progress origin-left": indeterminate
        }, className
      )}
      {...otherProps}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={mergeClasses(
          "bg-primary h-full size-full flex-1 transition-all",
          indicatorClassName
        )}
        style={{ transform: `translateX(-${100 - (appliedValue || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}
